// import node module libraries
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NoteProps {
  id: string;
  content?: string;
  createdAt: string;
  hidden?: boolean;
}

interface initialStateProps {
  note: NoteProps[];
  isNoteListVisible: boolean;
}

const initialState: initialStateProps = {
  note: [],
  isNoteListVisible: false,
};

const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    addNote: (state, action: PayloadAction<NoteProps>) => {
      state.note.push({
        id: action.payload.id,
        content: action.payload.content,
        createdAt: action.payload.createdAt,
        hidden: action.payload.hidden,
      });
    },
    updateNote: (state, action) => {
      const { id, content } = action.payload;
      const existingNote = state.note.find((note) => note.id === id);
      if (existingNote) {
        existingNote.content = content;
      }
    },
    deleteNote: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      state.note = state.note.filter((note) => note.id !== id);
    },
    hideNote: (state, action) => {
      const id = action.payload;
      const existingNote = state.note.find((note) => note.id === id);
      if (existingNote) {
        existingNote.hidden = true;
      }
    },
    showNote: (state, action) => {
      const id = action.payload;
      const existingNote = state.note.find((note) => note.id === id);
      if (existingNote) {
        existingNote.hidden = false;
      }
    },
    toggleNoteList: (state, action) => {
      state.isNoteListVisible = action.payload;
    },
  },
});

export const {
  addNote,
  updateNote,
  deleteNote,
  hideNote,
  showNote,
  toggleNoteList,
} = notesSlice.actions;
export default notesSlice.reducer;
